import {types} from 'mobx-state-tree';
import NormalizedMessageModel, {NormalizedMessageViews} from '../shared/normalizedMessageModel';

export type SyncedMessageOwnViews = {
  cid: string;
};

export type SyncedMessageViews = NormalizedMessageViews & SyncedMessageOwnViews;

const SyncedMessageModel = types
  .compose(
    types.model({
      id: types.number,
      createdAt: types.number
    }),
    NormalizedMessageModel
  )
  .views<SyncedMessageOwnViews>(self => {
    // tslint:disable-next-line:no-any
    const computed = (self as any) as SyncedMessageViews;

    return {
      get cid() {
        return computed.normalizedData.message.cid;
      }
    };
  });

export type SyncedMessage = typeof SyncedMessageModel.Type;

export default SyncedMessageModel;



// WEBPACK FOOTER //
// ./src/models/chatChannelModel/message/branches/syncedMessageModel.ts